import axios from "axios";

const api = axios.create({
  baseURL:
    "https://chat.googleapis.com/v1/spaces/AAAANwrGxxc/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=zaGyikC3l3rsNbW_PjgGz8nj4EJa4p4XuGCecowBCJs",
  headers: {
    "Content-Type": "application/json",
  },
});

export const sendGchat = async (chatPayload: any): Promise<any> => {
  return api.post("", chatPayload);
};
